uniform float uTime;
uniform float uBorderAlpha;
uniform float uStrikeAlpha;
uniform float uRadius;
uniform vec3 uColor;
uniform vec3 uAccentColor;

varying vec3 vPosition;
varying vec3 vModelPosition;

void main()
{
    if(vModelPosition.z < 0.0)
    {
        discard;
    }

    float dist = length(vPosition.xy);
    float normalized = clamp(dist / max(uRadius, 0.0001), 0.0, 1.05);
    if(normalized > 1.05)
    {
        discard;
    }

    float pulse = 0.5 + 0.5 * sin(normalized * 12.0 - uTime * 0.003 + dist * 3.0);
    float outerGlow = smoothstep(0.85, 0.95, normalized);
    float strikeStrength = (1.0 - normalized) * uStrikeAlpha * pulse;
    float borderStrength = outerGlow * uBorderAlpha;
    float alpha = max(strikeStrength, borderStrength) * mix(0.5, 1.0, pulse);

    vec3 gradient = mix(uColor, uAccentColor, pulse);
    vec3 finalColor = mix(gradient, vec3(1.0), pulse * 0.4);

    gl_FragColor = vec4(finalColor, alpha);
}

